export const RELEASE_TAGS = {
  security: { label: 'Security', bg: '#fde8e8', fg: '#9b1c1c' },
  analytics: { label: 'Analytics', bg: '#e1effe', fg: '#1e429f' },
  'data-protection': { label: 'Data protection', bg: '#edebfe', fg: '#5521b5' },
  feature: { label: 'Feature', bg: '#def7ec', fg: '#03543f' },
  info: { label: 'Info', bg: '#f3f4f6', fg: '#374151' },
}

export const TAG_ORDER = ['feature', 'security', 'data-protection', 'analytics', 'info']
